import { useQuery } from "@tanstack/react-query";

import { fetchPropertyTax } from "./api";
import type { Selection } from "../state/useSelectionStore";

/**
 * The commune a selection is taxed by.
 *
 * Taxe foncière is voted by the commune, so a neighbourhood inherits its
 * parent's rate and a department has none of its own — the API answers with the
 * middle of its communes in that case.
 */
export function taxingCode(selection: Selection | null): string | null {
  if (!selection) return null;
  if (selection.scope === "commune" || selection.scope === "departement") {
    return selection.code;
  }
  const commune = selection.parents?.find((p) => p.level === "commune");
  return commune?.code ?? null;
}

export function usePropertyTax(code: string | null) {
  return useQuery({
    queryKey: ["property-tax", code],
    queryFn: () => fetchPropertyTax(code!),
    enabled: code !== null,
    staleTime: Infinity,
    retry: false,
  });
}
